import * as React from 'react'

import { Section, type SelectOption } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import type AllowanceForm from 'modules/timeoff/lib/AllowanceForm'
import { cycleBeginOptionsLabel } from 'modules/timeoff/lib/dynamicTranslations'
import Allowance, { CYCLE_DURATION } from 'modules/timeoff/store/models/Allowance'

interface Props {
  allowance: Allowance
  allowanceForm: AllowanceForm
}

const CycleSettings = ({ allowance, allowanceForm }: Props) => {
  const cycleStartOptions: SelectOption[] = Object.keys(Allowance.CYCLE_START).map((value) => ({
    label: cycleBeginOptionsLabel(value),
    value,
  }))

  const cycleDurationOptions: SelectOption[] = CYCLE_DURATION.map((value) => ({
    label: i18n.tp('time_off.allowances.fields.cycle_settings.cycle_duration.months', {
      count: value,
    }),
    value,
  }))

  return (
    <Section.Form
      illustration="timer"
      title={i18n.t('time_off.allowances.page.cycles_settings.title')}
      description={i18n.t('time_off.allowances.page.cycles_settings.description')}
      submitLabel={i18n.t('common.submit')}
      extra={{ 'data-intercom-target': 'timeoff-allowances-cycles-settings' }}
    >
      <Select
        label={i18n.t('time_off.allowances.page.labels.cycle_begin_on')}
        field={allowanceForm.get('cycle_start')}
        options={cycleStartOptions}
        readonly={!allowance.isNew}
      />
      <Select
        label={i18n.t('time_off.allowances.page.labels.cycle_duration')}
        field={allowanceForm.get('cycle_length')}
        options={cycleDurationOptions}
        readonly={!allowance.isNew}
      />
    </Section.Form>
  )
}

export default observer(CycleSettings)
